import { useEffect, useRef, Fragment, useMemo } from "react"
import { Grid } from "@material-ui/core"
import FormSection from "../../components/FormSection"
import FormField from "../../components/FormField"
import { useQueryClient } from "react-query"
import { Form, useFormik, FormikProvider, FieldArray } from "formik"
import {
  useGetOtherRequirements,
  useGetServiceDetails,
  useGetUserTips,
  useGetVehicleRequirements
} from "../../services/queries"
import NCText from "../../shared/NCText"
import NCButton from "../../shared/NCButton"
import { makeStyles, Box } from "@material-ui/core"
import TopNavBar from "../../components/TopNavBar"
import { useState } from "react"
import NCCheckbox from "../../shared/NCCheckbox"
import { useGetClients } from "../../services/queries"
import { useClientRequest } from "../../services/mutations"
import { toast } from "react-toastify"
import * as Yup from "yup"
import NCLoader from "../../shared/NCLoader"
import NCModal from "../../shared/NCModal"
import { useNavigate } from "react-router"
import NCAddress from "../../shared/NCAddress"
import { arrangeWeekDays, formatAMPM } from "../../libs/utils"
import NCDatePicker from "../../shared/NCDatePicker"
import NCTimePicker from "../../shared/NCTimePicker"
import NCAutocomplete from "../../shared/NCAutocomplete"
import { useGetTimezones } from "../../services/queries"
import NotificationAlert from "../../components/notification/NotificationAlert"
import { DeleteIcon, UploadIcon } from "../../libs/icons"
import { format, isValid } from "date-fns"
import { useTranslation } from "react-i18next"
const useStyles = makeStyles((theme) => ({
  title: {
    fontSize: "20px"
  },
  text: {
    fontSize: "14px",
    fontWeight: "400"
  },
  checkedItems: {
    fontSize: "14px",
    fontWeight: "400"
  },
  checklistItems: {
    fontSize: "14px",
    fontWeight: "400",  
    [theme.breakpoints.down("xs")]: {
      display: "block",
    },
  },
  heading: {
    fontSize: "14px",
    fontWeight: "550"
  },
  form: {
    "& .MuiCheckbox-root": {
      paddingRight: "3px"
    }
  },
  container: {
    paddingBottom: "10px"
  }
}))

const AddRequest = () => {
  const cls = useStyles()
  const {t} = useTranslation();
  const nav = useNavigate()
  const attachmentRef = useRef()
  const queryClient = useQueryClient()
  const [search, setSearch] = useState(null)

  const { data: timezoneData, isLoading: tzLoading } = useGetTimezones()
  const timezoneOptions = useMemo(() => {
    const payload = timezoneData?.data?.data  // axios → API body → payload
    return (payload?.timezones || []).map(tz => ({ id: tz, name: tz }))
  }, [timezoneData, tzLoading])
  const { isLoading: otherRequirementLoading, data: otherRequirementsData } =
    useGetOtherRequirements()
  const { isLoading: serviceDetailLoading, data: serviceDetailsData } =
    useGetServiceDetails()
  const { isLoading: userTipsLoading, data: userTipsData } = useGetUserTips()
  const { isLoaing: vehicleRequirementLoading, data: vehicleRequirementsData } =
    useGetVehicleRequirements()
  const { data: clientData, isLoading: clientLoading } = useGetClients(
    null,
    search
  )
  const modalTitle = t("requests.discard_charges")
  const modalText = t("requests.discard_confirmation")
  const clientRequest = useClientRequest()
  const [open, setOpen] = useState(false)
  const days = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday"
  ]
  const handleClose = () => {
    setOpen(false)
  }
  const handleDiscard = () => {
    formik.resetForm()
    setOpen(false)
  }

  const updateGeoCordinates = (cordinates, dayIndex, key) => {
    const newCoordinates = [...cordinates[key]];
    newCoordinates.splice(dayIndex, 1);
    formik.setFieldValue(key, newCoordinates);
  }

  const updateGeoCordinatesOnDayAdd = (cordinates, dayIndex, key, value) => {
    const newCoordinates = [...cordinates[key]];
    newCoordinates.splice(dayIndex, 0, value)
    formik.setFieldValue(key, newCoordinates);
  }

  
  const handleCheckBoxClick = (day, childIndex) => {
    const prefix = `children[${childIndex}]`
    const child = formik.values.children[childIndex]
    if (child?.selectedDays) {
      if (child.selectedDays.includes(day)) {
        let dayIndex = child.selectedDays.indexOf(day)
        let prevPickUpAddress = [...child.aleg_pickup_addresses]
        prevPickUpAddress.splice(dayIndex, 1)
        formik.setFieldValue(`${prefix}.aleg_pickup_addresses`, prevPickUpAddress)
        let prevDropoffAddress = [...child.aleg_drop_off_addresses]
        prevDropoffAddress.splice(dayIndex, 1)
        formik.setFieldValue(`${prefix}.aleg_drop_off_addresses`, prevDropoffAddress)
        let prevbLegPickUpAddress = [...child.bleg_pickup_addresses]
        prevbLegPickUpAddress.splice(dayIndex, 1)
        formik.setFieldValue(`${prefix}.bleg_pickup_addresses`, prevbLegPickUpAddress)
        let prevbLegDropoffAddress = [...child.bleg_drop_off_addresses]
        prevbLegDropoffAddress.splice(dayIndex, 1)
        formik.setFieldValue(`${prefix}.bleg_drop_off_addresses`, prevbLegDropoffAddress)
        updateGeoCordinates(child, dayIndex, "aleg_pickup_addresses_geo")
        updateGeoCordinates(child, dayIndex, "aleg_drop_off_addresses_geo")
        updateGeoCordinates(child, dayIndex, "bleg_pickup_addresses_geo")
        updateGeoCordinates(child, dayIndex, "bleg_drop_off_addresses_geo")
        let remainingValues = child.selectedDays.filter(item => item !== day)
        formik.setFieldValue(`${prefix}.selectedDays`, remainingValues)
      } else {
        let newSelectedDays = arrangeWeekDays(days, [...child.selectedDays, day])
        formik.setFieldValue(`${prefix}.selectedDays`, newSelectedDays)
        let dayIndex = newSelectedDays.indexOf(day)
        let prevPickUpAddress = [...child.aleg_pickup_addresses]
        prevPickUpAddress.splice(dayIndex, 0, child?.defaultAddress)
        formik.setFieldValue(`${prefix}.aleg_pickup_addresses`, prevPickUpAddress)
        let prevDropoffAddress = [...child.aleg_drop_off_addresses]
        prevDropoffAddress.splice(dayIndex, 0, child?.schooladdress)
        formik.setFieldValue(`${prefix}.aleg_drop_off_addresses`, prevDropoffAddress)
        let prevBlegPickUpAddress = [...child.bleg_pickup_addresses]
        prevBlegPickUpAddress.splice(dayIndex, 0, child?.schooladdress)
        formik.setFieldValue(`${prefix}.bleg_pickup_addresses`, prevBlegPickUpAddress)
        let prevBlegDropoffAddress = [...child.bleg_drop_off_addresses]
        prevBlegDropoffAddress.splice(dayIndex, 0, child?.defaultAddress)
        formik.setFieldValue(`${prefix}.bleg_drop_off_addresses`, prevBlegDropoffAddress)
        updateGeoCordinatesOnDayAdd(child, dayIndex, "aleg_pickup_addresses_geo", {
          latitude: child?.defaultAddressLatitude, longitude: child?.defaultAddressLongitude
        })
        updateGeoCordinatesOnDayAdd(child, dayIndex, "aleg_drop_off_addresses_geo", {
          latitude: child?.schooladdressLatitude, longitude: child?.schooladdressLongitude
        })
        updateGeoCordinatesOnDayAdd(child, dayIndex, "bleg_pickup_addresses_geo", {
          latitude: child?.schooladdressLatitude, longitude: child?.schooladdressLongitude
        })
        updateGeoCordinatesOnDayAdd(child, dayIndex, "bleg_drop_off_addresses_geo", {
          latitude: child?.defaultAddressLatitude, longitude: child?.defaultAddressLongitude
        })
      }
    }
  }
  const formik = useFormik({
    initialValues: {
      starting_date: "",
      timezone: "America/New_York",
      default_pickup_address: "",
      default_pickup_address_geo: null,
      default_drop_off_address: "",
      default_drop_off_address_geo: null,
      children: [{
        client: "",
        start_bell_time: "",
        end_bell_time: "",
        schooladdress: "",
        schooladdressLatitude: "",
        schooladdressLongitude: "",
        defaultAddress: "",
        defaultAddressLatitude: "",
        defaultAddressLongitude: "",
        aleg_pickup_addresses: [],
        aleg_pickup_addresses_geo: [],
        aleg_drop_off_addresses: [],
        aleg_drop_off_addresses_geo: [],
        bleg_pickup_addresses: [],
        bleg_pickup_addresses_geo: [],
        bleg_drop_off_addresses: [],
        bleg_drop_off_addresses_geo: [],
        selectedDays: [],
        client_name: "",
        child_tips: [],
        child_vehicle_req: [],
        child_service_detail: [],
        child_other: [],
      }],
      additional_comment: "",
      attachment: null
    },
    enableReinitialize: true,
    validationSchema: Yup.object().shape(
      {
        starting_date: Yup.date()
          .typeError("Use format(MM/dd/YYYY)")
          .min(
            format(new Date().setUTCHours(0, 0, 0, 0), "MM/dd/yyyy"),
            t("requests.error.start_date_min")
          )
          .required(t("requests.error.start_date_required")),
        children: Yup.array()
          .of(
            Yup.object().shape({
              client: Yup.string().required(t("requests.error.client_required")),
              start_bell_time: Yup.date().typeError("Use format(hh:mm a)").nullable(),
              end_bell_time: Yup.date().typeError("Use format(hh:mm a)").nullable(),
              selectedDays: Yup.array()
                .of(Yup.string())
                .min(1, t("requests.error.min_one_day_selected")),
              aleg_pickup_addresses: Yup.array().when("start_bell_time", (startDate, schema) => {
                if (startDate && isValid(new Date(startDate))) {
                  return schema.of(Yup.string().required(t("requests.error.pickup_address_required")))
                }
                return schema.of(Yup.string().nullable())
              }),
              aleg_drop_off_addresses: Yup.array().when("start_bell_time", (startDate, schema) => {
                if (startDate && isValid(new Date(startDate))) {
                  return schema.of(Yup.string().required(t("requests.error.dropoff_adress_required")))
                }
                return schema.of(Yup.string().nullable())
              }),
              bleg_pickup_addresses: Yup.array().when("end_bell_time", (endDate, schema) => {
                if (endDate && isValid(new Date(endDate))) {
                  return schema.of(Yup.string().required(t("requests.error.pickup_address_required")))
                }
                return schema.of(Yup.string().nullable())
              }),
              bleg_drop_off_addresses: Yup.array().when("end_bell_time", (endDate, schema) => {
                if (endDate && isValid(new Date(endDate))) {
                  return schema.of(Yup.string().required(t("requests.error.dropoff_adress_required")))
                }
                return schema.of(Yup.string().nullable())
              }),
            }).test(
              "bell-times-order",
              t("requests.error.less_than_b_leg_time") || "Start bell time must be before end bell time",
              function (child) {
                const { start_bell_time, end_bell_time } = child
                if (start_bell_time && end_bell_time && isValid(new Date(start_bell_time)) && isValid(new Date(end_bell_time))) {
                  return new Date(start_bell_time) < new Date(end_bell_time)
                }
                return true
              }
            )
          )
          .min(1, "At least one client is required"),
      },
      []
    ),
    onSubmit: values => {
      const children = values.children.map(child => {
        let alegPickupAddress = [...child.aleg_pickup_addresses]
        let alegDropOffAddress = [...child.aleg_drop_off_addresses]
        let blegPickupAddress = [...child.bleg_pickup_addresses]
        let blegDropOffAddress = [...child.bleg_drop_off_addresses]
        let alegPickupAddressGeo = [...child.aleg_pickup_addresses_geo]
        let alegDropOffAddressGeo = [...child.aleg_drop_off_addresses_geo]
        let blegPickupAddressGeo = [...child.bleg_pickup_addresses_geo]
        let blegDropOffAddressGeo = [...child.bleg_drop_off_addresses_geo]

        let newAddresses = child.selectedDays.reduce(
          (acc, item) => {
            if (item) {
              let weekDay = days.indexOf(item) + 1
              let aleg_pick = alegPickupAddress.splice(0, 1)
              let aleg_drop = alegDropOffAddress.splice(0, 1)
              let bleg_pick = blegPickupAddress.splice(0, 1)
              let bleg_drop = blegDropOffAddress.splice(0, 1)
              let aleg_pick_geo = alegPickupAddressGeo.splice(0, 1)
              let aleg_drop_geo = alegDropOffAddressGeo.splice(0, 1)
              let bleg_pick_geo = blegPickupAddressGeo.splice(0, 1)
              let bleg_drop_geo = blegDropOffAddressGeo.splice(0, 1)

              acc.pickAddress_arr.push({
                week_day: weekDay,
                location: { address: aleg_pick[0], ...aleg_pick_geo[0] },
                drop_location: { address: aleg_drop[0], ...aleg_drop_geo[0] }
              })
              acc.dropAddress_arr.push({
                week_day: weekDay,
                location: { address: bleg_drop[0], ...bleg_drop_geo[0] },
                pickup_location: { address: bleg_pick[0], ...bleg_pick_geo[0] }
              })
            }
            return acc
          },
          { pickAddress_arr: [], dropAddress_arr: [] }
        )

        return {
          client: child.client,
          start_bell_time: child.start_bell_time
            ? new Date(`${format(new Date(values.starting_date), "yyyy-MM-dd")} ${formatAMPM(child.start_bell_time)}`).toISOString()
            : null,
          end_bell_time: child.end_bell_time
            ? new Date(`${format(new Date(values.starting_date), "yyyy-MM-dd")} ${formatAMPM(child.end_bell_time)}`).toISOString()
            : null,
          client_pickup_address: { address: child.defaultAddress, latitude: child.defaultAddressLatitude, longitude: child.defaultAddressLongitude },
          client_dropoff_address: { address: child.schooladdress, latitude: child.schooladdressLatitude, longitude: child.schooladdressLongitude },
          pickup_addresses: child.start_bell_time ? newAddresses.pickAddress_arr : [],
          drop_off_addresses: child.end_bell_time ? newAddresses.dropAddress_arr : [],
          // Per-child specific detail overrides (optional — parent acts as default)
          tips: child.child_tips || [],
          vehicle_req: child.child_vehicle_req || [],
          service_detail: child.child_service_detail || [],
          other: child.child_other || [],
        }
      })

      const obj = {
        starting_date: values.starting_date,
        timezone: values.timezone,
        default_pickup_address: values.default_pickup_address ? {
          address: values.default_pickup_address,
          latitude: values.default_pickup_address_geo?.latitude,
          longitude: values.default_pickup_address_geo?.longitude,
          place: values.default_pickup_address_geo?.place || ""
        } : null,
        default_drop_off_address: values.default_drop_off_address ? {
          address: values.default_drop_off_address,
          latitude: values.default_drop_off_address_geo?.latitude,
          longitude: values.default_drop_off_address_geo?.longitude,
          place: values.default_drop_off_address_geo?.place || ""
        } : null,
        children: children,
        additional_comment: values.additional_comment,
        attachment: values.attachment
      }
      clientRequest.mutate(obj, {
        onSuccess: async () => {
          toast.success("Request has been added successfully")
          queryClient.invalidateQueries(["getNotificationData"])
          queryClient.refetchQueries(["getNotificationSummary"])
          nav("/requests")
        }
      })
    }
  })
  // Track previous client IDs to only auto-fill on first selection/change
  const prevClientIds = useRef({})
  useEffect(() => {
    formik.values.children?.forEach((child, childIndex) => {
      if (!child.client) {
        delete prevClientIds.current[childIndex]
        return
      }
      // Only auto-fill if client just changed (first selection or switched client)
      if (prevClientIds.current[childIndex] === child.client) return
      prevClientIds.current[childIndex] = child.client

      const obj = clientData?.data?.data?.results?.filter(
        item => item.id == child.client
      )
      if (!obj?.[0]) return
      const clientAddress = obj[0]?.address
      const clientLat = obj[0]?.latitude
      const clientLng = obj[0]?.longitude
      const schoolAddress = obj[0]?.client_subadmin_info?.address
      const schoolLat = obj[0]?.client_subadmin_info?.latitude
      const schoolLng = obj[0]?.client_subadmin_info?.longitude

      // Prefer form-level default addresses if already entered
      const formPickup = formik.values.default_pickup_address
      const formDropoff = formik.values.default_drop_off_address
      const formPickupGeo = formik.values.default_pickup_address_geo
      const formDropoffGeo = formik.values.default_drop_off_address_geo

      const finalPickup = formPickup || clientAddress
      const finalPickupLat = formPickupGeo?.latitude || clientLat
      const finalPickupLng = formPickupGeo?.longitude || clientLng
      const finalDropoff = formDropoff || schoolAddress
      const finalDropoffLat = formDropoffGeo?.latitude || schoolLat
      const finalDropoffLng = formDropoffGeo?.longitude || schoolLng

      // Store for use by day checkboxes
      formik.setFieldValue(`children[${childIndex}].client_name`, obj[0]?.name || "")
      formik.setFieldValue(`children[${childIndex}].schooladdressLatitude`, finalDropoffLat)
      formik.setFieldValue(`children[${childIndex}].schooladdressLongitude`, finalDropoffLng)
      formik.setFieldValue(`children[${childIndex}].schooladdress`, finalDropoff)
      formik.setFieldValue(`children[${childIndex}].defaultAddressLatitude`, finalPickupLat)
      formik.setFieldValue(`children[${childIndex}].defaultAddressLongitude`, finalPickupLng)
      formik.setFieldValue(`children[${childIndex}].defaultAddress`, finalPickup)
    })
  }, [formik.values.children?.map(c => c.client).join(","), formik.values.default_pickup_address, formik.values.default_drop_off_address])

  // Auto-fill default addresses into weekly schedule — only fill empty slots
  useEffect(() => {
    formik.values.children?.forEach((child, childIndex) => {
      child.selectedDays?.forEach((item, index) => {
        // Only fill if not already manually set
        if (!child.aleg_pickup_addresses?.[index]) {
          formik.setFieldValue(`children[${childIndex}].aleg_pickup_addresses_geo[${index}]`, {
            latitude: child.defaultAddressLatitude || null,
            longitude: child.defaultAddressLongitude || null
          })
          formik.setFieldValue(`children[${childIndex}].aleg_pickup_addresses[${index}]`, child.defaultAddress || null)
        }
        if (!child.bleg_drop_off_addresses?.[index]) {
          formik.setFieldValue(`children[${childIndex}].bleg_drop_off_addresses_geo[${index}]`, {
            latitude: child.defaultAddressLatitude || null,
            longitude: child.defaultAddressLongitude || null
          })
          formik.setFieldValue(`children[${childIndex}].bleg_drop_off_addresses[${index}]`, child.defaultAddress || null)
        }
      })
    })
  }, [formik.values.children?.map(c => c.defaultAddress).join(",")])

  // Auto-fill school addresses into weekly schedule — only fill empty slots
  useEffect(() => {
    formik.values.children?.forEach((child, childIndex) => {
      child.selectedDays?.forEach((item, index) => {
        // Only fill if not already manually set
        if (!child.aleg_drop_off_addresses?.[index]) {
          formik.setFieldValue(`children[${childIndex}].aleg_drop_off_addresses_geo[${index}]`, {
            latitude: child.schooladdressLatitude || null,
            longitude: child.schooladdressLongitude || null
          })
          formik.setFieldValue(`children[${childIndex}].aleg_drop_off_addresses[${index}]`, child.schooladdress || null)
        }
        if (!child.bleg_pickup_addresses?.[index]) {
          formik.setFieldValue(`children[${childIndex}].bleg_pickup_addresses_geo[${index}]`, {
            latitude: child.schooladdressLatitude || null,
            longitude: child.schooladdressLongitude || null
          })
          formik.setFieldValue(`children[${childIndex}].bleg_pickup_addresses[${index}]`, child.schooladdress || null)
        }
      })
    })
  }, [formik.values.children?.map(c => c.schooladdress).join(",")])

  // Auto-sync default addresses to children WITHOUT a client selected yet
  useEffect(() => {
    const pickup = formik.values.default_pickup_address
    const dropoff = formik.values.default_drop_off_address
    const pickupGeo = formik.values.default_pickup_address_geo
    const dropoffGeo = formik.values.default_drop_off_address_geo
    if (!pickup && !dropoff) return
    formik.values.children?.forEach((child, childIndex) => {
      // Only auto-fill children that haven't had a client selected yet
      if (child.client) return
      if (pickup) {
        formik.setFieldValue(`children[${childIndex}].defaultAddress`, pickup)
        if (pickupGeo) {
          formik.setFieldValue(`children[${childIndex}].defaultAddressLatitude`, pickupGeo.latitude || "")
          formik.setFieldValue(`children[${childIndex}].defaultAddressLongitude`, pickupGeo.longitude || "")
        }
      }
      if (dropoff) {
        formik.setFieldValue(`children[${childIndex}].schooladdress`, dropoff)
        if (dropoffGeo) {
          formik.setFieldValue(`children[${childIndex}].schooladdressLatitude`, dropoffGeo.latitude || "")
          formik.setFieldValue(`children[${childIndex}].schooladdressLongitude`, dropoffGeo.longitude || "")
        }
      }
    })
  }, [formik.values.default_pickup_address, formik.values.default_drop_off_address])

  // Filter out already-selected clients from options
  const getFilteredClientOptions = (currentChildIndex) => {
    const allClients = clientData?.data?.data?.results || []
    const selectedIds = formik.values.children
      .filter((_, idx) => idx !== currentChildIndex)
      .map(c => c.client)
      .filter(Boolean)
    const hasOtherSelected = selectedIds.length > 0
    return allClients.filter(c => {
      if (selectedIds.includes(c.id)) return false
      if (c.solo_only && hasOtherSelected) return false
      if (c.solo_only && formik.values.children.length > 1 && formik.values.children.some((ch, i) => i !== currentChildIndex && ch.client)) return false
      return true
    })
  }

  const hasSoloClient = useMemo(() => {
    const allClients = clientData?.data?.data?.results || []
    const selectedIds = formik.values.children.map(c => c.client).filter(Boolean)
    return allClients.some(c => selectedIds.includes(c.id) && c.solo_only)
  }, [clientData, formik.values.children])

  return (
    <Grid container>
      <Grid item xs={6}>
        <Box mb={2}>
          <NCText variant={"h4"}>{t("requests.add_request")}</NCText>
        </Box>
      </Grid>
      <Grid item xs={6}>
        <Box display={"flex"} justifyContent={"flex-end"}>
          <NotificationAlert />
        </Box>
      </Grid>

      <Grid item xs={12}>
        <Box>
          <TopNavBar />
        </Box>
      </Grid>
      <FormikProvider value={formik}>
        <Form className={cls.form} onSubmit={formik.handleSubmit}>
          <Grid container>
            <Grid item xs={12} sm={12} md={12}>
              <FormSection
                title={<span style={{ fontWeight: "500" }}>{t("requests.ride_details")}</span>}
              >
                <Grid container spacing={2}>
                  <Grid item xs={12} md={6}>
                    <FormField
                      as={NCDatePicker}
                      label={t("requests.starting_date")}
                      name={"starting_date"}
                      onChange={v => formik.setFieldValue("starting_date", v)}
                      min={new Date(Date.now() + 24 * 60 * 60 * 1000).toISOString().split("T")[0]}
                      required={true}
                      dateTime={true}
                      error={formik?.errors?.starting_date}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <FormField
                      as={NCAutocomplete}
                      label="Timezone"
                      name="timezone"
                      options={timezoneOptions}
                      getOptionSelected={(option, value) => option.id === value}
                      onChange={v => formik.setFieldValue("timezone", v)}
                    />
                  </Grid>
                </Grid>
                <Box mt={2}>
                  <FormSection
                    title={<span style={{ fontSize: "14px", fontWeight: "500" }}>Default Addresses (applied to all clients)</span>}
                    customBgColor="#E5E7EB"
                    subSection={true}
                  >
                    <Grid container spacing={2}>
                      <Grid item xs={12} md={6}>
                        <FormField
                          as={NCAddress}
                          label={t("requests.pickup_address")}
                          name="default_pickup_address"
                          onChange={e => {
                            formik.setFieldValue("default_pickup_address_geo", {
                              latitude: e?.geometry?.latitude,
                              longitude: e?.geometry?.longitude,
                              place: e?.place_id || ""
                            })
                            formik.setFieldValue("default_pickup_address", e?.name || "")
                          }}
                        />
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <FormField
                          as={NCAddress}
                          label={t("requests.drop_address")}
                          name="default_drop_off_address"
                          onChange={e => {
                            formik.setFieldValue("default_drop_off_address_geo", {
                              latitude: e?.geometry?.latitude,
                              longitude: e?.geometry?.longitude,
                              place: e?.place_id || ""
                            })
                            formik.setFieldValue("default_drop_off_address", e?.name || "")
                          }}
                        />
                      </Grid>
                    </Grid>
                  </FormSection>
                </Box>
              </FormSection>
              <FieldArray
                  name="children"
                  render={arrayHelpers => (
                    <>
                      {formik.values.children?.map((child, childIndex) => (
                        <FormSection
                          key={childIndex}
                          title={<span style={{ fontWeight: "500" }}>Client {childIndex + 1}</span>}
                          subTitle={
                            formik.values.children.length > 1 && (
                              <NCButton size="small" variant="outlined" color="secondary"
                                onClick={() => arrayHelpers.remove(childIndex)}>
                                Remove
                              </NCButton>
                            )
                          }
                        >
                          <Grid container spacing={2}>
                            <Grid item xs={12} md={12} style={{ marginBottom: -8 }}>
                              <FormField
                                as={NCAutocomplete}
                                options={getFilteredClientOptions(childIndex)}
                                label={t("requests.select_client")}
                                name={`children[${childIndex}].client`}
                                onChange={v => formik.setFieldValue(`children[${childIndex}].client`, v)}
                                loading={clientLoading}
                                onSearch={v => setSearch(v)}
                                required={true}
                                error={formik?.errors?.children?.[childIndex]?.client}
                              />
                            </Grid>
                          </Grid>
                          <FormSection
                            title={<span style={{ fontSize: "14px", fontWeight: "500" }}>{t("requests.frequency")}</span>}
                            customBgColor="#E5E7EB"
                            subSection={true}
                          >
                            <Grid container alignItems="center">
                              <Grid item xs={12} lg={1}>
                                <NCText className={cls.text}>{t("requests.select_days")}</NCText>
                              </Grid>
                              <Grid item container xs={11} className={cls.checklistItems} style={{ gap: "20px" }}>
                                {days.map((day, i) => (
                                  <NCText className={cls.checkedItems} key={i}>
                                    <NCCheckbox
                                      name={`children[${childIndex}].selectedDays[${i}]`}
                                      color="primary"
                                      onChange={() => handleCheckBoxClick(day, childIndex)}
                                      size="small"
                                    />
                                    {day}
                                  </NCText>
                                ))}
                              </Grid>
                              {formik?.errors?.children?.[childIndex]?.selectedDays && typeof formik.errors.children[childIndex].selectedDays === "string" ? (
                                <Box color={"#f44336"} mx={"14px"}>
                                  <NCText variant="caption">{formik.errors.children[childIndex].selectedDays}</NCText>
                                </Box>
                              ) : null}
                            </Grid>
                          </FormSection>
                          <Grid container spacing={3}>
                            <Grid item xs={12}>
                              <FormSection
                                title={<span style={{ fontSize: "14px", fontWeight: "500" }}>{t("requests.aleg")}</span>}
                                customBgColor="#E5E7EB"
                                subSection={true}
                              >
                                <Grid container alignItems="center" spacing={2} className={cls.checklistItems}>
                                  <Grid item xs={6} sm={6} md={2}>
                                    <NCText className={cls.text}>{t("requests.bell_time")}</NCText>
                                  </Grid>
                                  <Grid item xs={10} sm={6} md={10}>
                                    <FormField
                                      as={NCTimePicker}
                                      placeholder={t("requests.enter_start_bell_time")}
                                      name={`children[${childIndex}].start_bell_time`}
                                      onChange={v => formik.setFieldValue(`children[${childIndex}].start_bell_time`, v)}
                                      error={formik?.errors?.children?.[childIndex]?.start_bell_time}
                                    />
                                  </Grid>
                                  {child?.selectedDays?.map((day, i) => (
                                    <Fragment key={`${day}${i}`}>
                                      <Grid item xs={6} sm={6} md={2}>
                                        <NCText className={cls.text}>{day}</NCText>
                                      </Grid>
                                      <Grid item xs={6} sm={6} md={5}>
                                        <FormField
                                          as={NCAddress}
                                          label={t("requests.pickup_address")}
                                          name={`children[${childIndex}].aleg_pickup_addresses.${i}`}
                                          onChange={e => {
                                            formik.setFieldValue(`children[${childIndex}].aleg_pickup_addresses_geo[${i}]`, {
                                              latitude: e?.geometry?.latitude,
                                              longitude: e?.geometry?.longitude
                                            })
                                            formik.setFieldValue(`children[${childIndex}].aleg_pickup_addresses[${i}]`, e?.name)
                                          }}
                                          required={true}
                                          error={formik?.errors?.children?.[childIndex]?.aleg_pickup_addresses?.[i]}
                                        />
                                      </Grid>
                                      <Grid item xs={6} sm={6} md={5}>
                                        <FormField
                                          as={NCAddress}
                                          label={t("requests.drop_address")}
                                          name={`children[${childIndex}].aleg_drop_off_addresses.${i}`}
                                          onChange={e => {
                                            formik.setFieldValue(`children[${childIndex}].aleg_drop_off_addresses_geo[${i}]`, {
                                              latitude: e?.geometry?.latitude,
                                              longitude: e?.geometry?.longitude
                                            })
                                            formik.setFieldValue(`children[${childIndex}].aleg_drop_off_addresses[${i}]`, e?.name)
                                          }}
                                          required={true}
                                          error={formik?.errors?.children?.[childIndex]?.aleg_drop_off_addresses?.[i]}
                                        />
                                      </Grid>
                                    </Fragment>
                                  ))}
                                </Grid>
                              </FormSection>
                            </Grid>
                            <Grid item xs={12}>
                              <FormSection
                                title={<span style={{ fontSize: "14px", fontWeight: "500" }}>{t("requests.bleg")}</span>}
                                customBgColor="#E5E7EB"
                                subSection={true}
                              >
                                <Grid container alignItems="center" spacing={2} className={cls.checklistItems}>
                                  <Grid item xs={6} sm={6} md={2}>
                                    <NCText className={cls.text}>{t("requests.bell_time")}</NCText>
                                  </Grid>
                                  <Grid item xs={10} sm={6} md={10}>
                                    <FormField
                                      as={NCTimePicker}
                                      placeholder={t("requests.enter_end_bell_time")}
                                      disablePast={true}
                                      name={`children[${childIndex}].end_bell_time`}
                                      onChange={v => formik.setFieldValue(`children[${childIndex}].end_bell_time`, v)}
                                      error={formik?.errors?.children?.[childIndex]?.end_bell_time}
                                    />
                                  </Grid>
                                  {child?.selectedDays?.map((day, i) => (
                                    <Fragment key={`${day}${i}`}>
                                      <Grid item xs={6} sm={6} md={2}>
                                        <NCText className={cls.text}>{day}</NCText>
                                      </Grid>
                                      <Grid item xs={6} sm={6} md={5}>
                                        <FormField
                                          as={NCAddress}
                                          label={t("requests.pickup_address")}
                                          name={`children[${childIndex}].bleg_pickup_addresses.${i}`}
                                          onChange={e => {
                                            formik.setFieldValue(`children[${childIndex}].bleg_pickup_addresses_geo[${i}]`, {
                                              latitude: e?.geometry?.latitude,
                                              longitude: e?.geometry?.longitude
                                            })
                                            formik.setFieldValue(`children[${childIndex}].bleg_pickup_addresses[${i}]`, e?.name)
                                          }}
                                          required={true}
                                          error={formik?.errors?.children?.[childIndex]?.bleg_pickup_addresses?.[i]}
                                        />
                                      </Grid>
                                      <Grid item xs={6} sm={6} md={5}>
                                        <FormField
                                          as={NCAddress}
                                          label={t("requests.drop_address")}
                                          name={`children[${childIndex}].bleg_drop_off_addresses.${i}`}
                                          onChange={e => {
                                            formik.setFieldValue(`children[${childIndex}].bleg_drop_off_addresses_geo[${i}]`, {
                                              latitude: e?.geometry?.latitude,
                                              longitude: e?.geometry?.longitude
                                            })
                                            formik.setFieldValue(`children[${childIndex}].bleg_drop_off_addresses[${i}]`, e?.name)
                                          }}
                                          required={true}
                                          error={formik?.errors?.children?.[childIndex]?.bleg_drop_off_addresses?.[i]}
                                        />
                                      </Grid>
                                    </Fragment>
                                  ))}
                                </Grid>
                              </FormSection>
                            </Grid>
                            <Grid item xs={12}>
                              <FormSection
                                title={<span style={{ fontSize: "14px", fontWeight: "500" }}>{t("requests.specific_details") + " — " + (child.client ? (formik.values.children[childIndex]?.client_name || `Client #${childIndex + 1}`) : `Client #${childIndex + 1}`)}</span>}
                                customBgColor="#FEF3C7"
                                subSection={true}
                              >
                                <Grid container className={cls.container}>
                                  {userTipsData &&
                                    userTipsData?.data?.data.slice().sort((a, b) => a.id - b.id).map((item) => (
                                      <Grid item xs={12} md={2}>
                                        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                          <NCCheckbox
                                            color="primary"
                                            size="small"
                                            checked={(formik.values.children[childIndex]?.child_tips || []).includes(item.id)}
                                            onChange={e => {
                                              const current = formik.values.children[childIndex]?.child_tips || []
                                              const next = e.target.checked
                                                ? [...current, item.id]
                                                : current.filter(id => id !== item.id)
                                              formik.setFieldValue(`children[${childIndex}].child_tips`, next)
                                            }}
                                          />
                                          <NCText className={cls.checkedItems} style={{ wordWrap: "break-word" }}>
                                            {item.name}
                                          </NCText>
                                        </div>
                                      </Grid>
                                    ))}
                                </Grid>
                                <Grid container className={cls.container}>
                                  {vehicleRequirementsData &&
                                    vehicleRequirementsData?.data?.data.map((item) => (
                                      <Grid item xs={12} md={2}>
                                        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                          <NCCheckbox
                                            color="primary"
                                            size="small"
                                            checked={(formik.values.children[childIndex]?.child_vehicle_req || []).includes(item.id)}
                                            onChange={e => {
                                              const current = formik.values.children[childIndex]?.child_vehicle_req || []
                                              const next = e.target.checked
                                                ? [...current, item.id]
                                                : current.filter(id => id !== item.id)
                                              formik.setFieldValue(`children[${childIndex}].child_vehicle_req`, next)
                                            }}
                                          />
                                          <NCText className={cls.checkedItems} style={{ wordWrap: "break-word" }}>
                                            {item.name}
                                          </NCText>
                                        </div>
                                      </Grid>
                                    ))}
                                </Grid>
                                <Grid container className={cls.container}>
                                  {serviceDetailsData &&
                                    serviceDetailsData?.data?.data.map((item) => (
                                      <Grid item xs={12} md={2}>
                                        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                          <NCCheckbox
                                            color="primary"
                                            size="small"
                                            checked={(formik.values.children[childIndex]?.child_service_detail || []).includes(item.id)}
                                            onChange={e => {
                                              const current = formik.values.children[childIndex]?.child_service_detail || []
                                              const next = e.target.checked
                                                ? [...current, item.id]
                                                : current.filter(id => id !== item.id)
                                              formik.setFieldValue(`children[${childIndex}].child_service_detail`, next)
                                            }}
                                          />
                                          <NCText className={cls.checkedItems} style={{ wordWrap: "break-word" }}>
                                            {item.name}
                                          </NCText>
                                        </div>
                                      </Grid>
                                    ))}
                                </Grid>
                                <Grid container className={cls.container}>
                                  {otherRequirementsData &&
                                    otherRequirementsData?.data?.data.map((item) => {
                                      const isAlone = item.code === "ALONE"
                                      const locked = isAlone && hasSoloClient
                                      return (
                                      <Grid item xs={12} md={2}>
                                        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                          <NCCheckbox
                                            color="primary"
                                            size="small"
                                            checked={(formik.values.children[childIndex]?.child_other || []).includes(item.id)}
                                            disabled={locked}
                                            onChange={e => {
                                              const current = formik.values.children[childIndex]?.child_other || []
                                              const next = e.target.checked
                                                ? [...current, item.id]
                                                : current.filter(id => id !== item.id)
                                              formik.setFieldValue(`children[${childIndex}].child_other`, next)
                                            }}
                                          />
                                          <NCText className={cls.checkedItems} style={{ wordWrap: "break-word", opacity: locked ? 0.6 : 1 }}>
                                            {item.name}{locked ? " (locked)" : ""}
                                          </NCText>
                                        </div>
                                      </Grid>
                                    )})}
                                </Grid>
                              </FormSection>
                            </Grid>
                          </Grid>
                        </FormSection>
                      ))}
                      <Box mt={2} mb={3} display="flex" justifyContent="flex-end">
                        {hasSoloClient ? (
                          <NCText style={{ color: "#D97705", fontSize: "13px", marginRight: "12px" }}>
                            ⚠ Solo-only client selected — cannot add more clients.
                          </NCText>
                        ) : (
                          <Box>
                            <NCButton
                              variant="contained"
                              color="primary"
                              onClick={() => arrayHelpers.push({
                            client: "",
                            start_bell_time: "",
                            end_bell_time: "",
                            schooladdress: formik.values.default_drop_off_address || "",
                            schooladdressLatitude: formik.values.default_drop_off_address_geo?.latitude || "",
                            schooladdressLongitude: formik.values.default_drop_off_address_geo?.longitude || "",
                            defaultAddress: formik.values.default_pickup_address || "",
                            defaultAddressLatitude: formik.values.default_pickup_address_geo?.latitude || "",
                            defaultAddressLongitude: formik.values.default_pickup_address_geo?.longitude || "",
                            aleg_pickup_addresses: [],
                            aleg_pickup_addresses_geo: [],
                            aleg_drop_off_addresses: [],
                            aleg_drop_off_addresses_geo: [],
                            bleg_pickup_addresses: [],
                            bleg_pickup_addresses_geo: [],
                            bleg_drop_off_addresses: [],
                            bleg_drop_off_addresses_geo: [],
                            selectedDays: [],
                            client_name: "",
                            child_tips: [],
                            child_vehicle_req: [],
                            child_service_detail: [],
                            child_other: [],
                          })}
                        >
                          + Add Another Client
                        </NCButton>
                        </Box>
                        )}
                      </Box>
                    </>
                  )}
                />
            </Grid>
            <Grid item xs={12} sm={8} md={12}>
              <FormSection
                title={
                  <span style={{ fontWeight: "500" }}>{t("requests.additional_comments")}</span>
                }
              >
                <FormField
                  label={t("requests.add_comment")}
                  multiline
                  rows={3}
                  name={"additional_comment"}
                  required={true}
                  error={formik?.errors?.additional_comment}
                />
                <label htmlFor="upload-doc">
                  <input
                    style={{ display: "none" }}
                    id="upload-doc"
                    name="upload-doc"
                    ref={attachmentRef}
                    type="file"
                    value={formik?.values?.attachment?.files}
                    onChange={e => {
                      const file = e.target.files?.[0]
                      if (file && file.size > 10 * 1024 * 1024) {
                        toast.error(t("requests.bip_file_too_large"))
                        e.target.value = null
                        return
                      }
                      formik.setFieldValue("attachment", file)
                    }}
                  />
                  {formik?.values?.attachment ? null : (
                    <Box className="cursor-pointer">
                      <Grid
                        container
                        direction="row"
                        alignItems="center"
                        spacing={2}
                      >
                        <Grid item>
                          <UploadIcon />
                        </Grid>
                        <Grid item>
                          <NCText color={"primary"}>
                            {t("requests.upload_bip")}
                          </NCText>
                        </Grid>
                      </Grid>
                    </Box>
                  )}
                </label>
                {formik?.values?.attachment ? (
                  <Grid
                    container
                    direction="row"
                    alignItems="center"
                    spacing={2}
                  >
                    <Grid item>
                      <NCText color={"primary"}>
                        {formik?.values?.attachment?.name}
                      </NCText>
                    </Grid>
                    <Grid item>
                      <DeleteIcon
                        className="cursor-pointer"
                        onClick={() => {
                          attachmentRef.current.value = null
                          formik.setFieldValue("attachment", null)
                        }}
                      />
                    </Grid>
                  </Grid>
                ) : null}
              </FormSection>
            </Grid>
          </Grid>
          <Box bgcolor={"#F3FAFC"} p={2} mx={-3} ml={-4} display={"flex"}>
            <Grid item xs={12}>
              <Grid
                container
                direction="row"
                justifyContent="flex-end"
                spacing={2}
              >
                <Grid item>
                  <NCButton
                    onClick={() => nav("/requests")}
                    variant="outlined"
                    color="primary"
                  >
                    {t("common.cancel")}
                  </NCButton>
                </Grid>
                <Grid item>
                  <NCButton variant="contained" color="primary" type="submit">
                    {t("common.save")}
                  </NCButton>
                </Grid>
              </Grid>
            </Grid>
          </Box>
          <NCModal
            open={open}
            title={modalTitle}
            text={modalText}
            onClose={handleClose}
            handleDiscard={handleDiscard}
          />
          {(otherRequirementLoading ||
            serviceDetailLoading ||
            userTipsLoading ||
            vehicleRequirementLoading ||
            clientRequest.isLoading) && <NCLoader open={true} />}
        </Form>
      </FormikProvider>
    </Grid>
  )
}

export default AddRequest
